import { fichajesService } from '@services/fichajes';
import { FileListItemComponent } from './FileListItemComponent';
import { File } from '@screens/TrackHorasList/types';

const FileListComponent = ({ files, handleDelete }: any) => {
  const handleDownload = async (file: File) => {
    const response = await fichajesService.download({ ...file });
    const urlBlob = window.URL.createObjectURL(new Blob([response?.data]));
    const a = document.createElement('a');
    a.href = urlBlob;
    a.download = file.name;
    a.click();
    window.URL.revokeObjectURL(urlBlob);
  };

  console.log(handleDelete)

  return (
    <ul style={{ listStyle: 'none', padding: 0, marginTop: '8px' }}>
      {files.map((file: File) => (
        <FileListItemComponent {...{ file, handleDownload, handleDelete }} />
      ))}
    </ul>
  );
};

export { FileListComponent };
